export const THEME_VARIABLES = {
  variable: {
    spacing: {
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '48px',
      xxl: '96px',
    },
    borderRadius: '6px',
    fontSize: {
      xxs: '10px', // condensed chart labels
      xs: '12px', // chart labels / footnotes / tag text
      sm: '14px', // body text / default buttons
      md: '16px', // large text / large buttons / tabs
      lg: '18px', // card headers
      xl: '24px', // page headers
      xxl: '52px', // page statements
    },
    lineHeight: 1.5,
    fontFamily: {
      primary: '"Source Sans Pro", "Segoe UI", "Droid Sans", Tahoma, Arial, sans-serif',
      secondary: '"Roobert", sans-serif',
    },
    opacity: {
      disabled: 0.5,
    },
  },
};
